import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="datepicker"
export default class extends Controller {
	static targets = ["dropdown", "datefield"]

	connect() {}

	createDatepicker() {
		moment.locale("de")

		// Aktuelles Datum (entweder heute oder was im datefield steht)
		let date = moment()
		if (this.datefieldTarget.value != "") {
			date = moment(this.datefieldTarget.value, "DD.MM.YYYY")
		}

		// Nodetree erstellen, Monat oben in die Mitte, Wochentage und Datumsgitter hinzufügen
		this.createHtmlNodeTree()
		this.mth_element.textContent = date.format("MMMM YYYY")
		this.populateWeekdays()
		this.populateDates()

		// Event-Listener fuer die Pfeile
		this.next_mth_element.dataset.action = "click->datepicker#goToNextMonth"
		this.prev_mth_element.dataset.action = "click->datepicker#goToPrevMonth"
	}

	createHtmlNodeTree() {
		// HTML-Elemente
		this.date_picker_element = document.createElement("div")
		this.date_picker_element.classList.add("date_picker")
		this.dates_element = document.createElement("div")
		this.dates_element.classList.add("dates")
		this.month_element = document.createElement("div")
		this.month_element.classList.add("month")
		this.prev_mth_element = document.createElement("div")
		this.prev_mth_element.classList.add("prev_mth", "arrows")
		this.prev_mth_element.innerHTML = svgPfeilLinks
		this.next_mth_element = document.createElement("div")
		this.next_mth_element.classList.add("next_mth", "arrows")
		this.next_mth_element.innerHTML = svgPfeilRechts
		this.mth_element = document.createElement("div")
		this.mth_element.classList.add("mth")
		this.weekdays_element = document.createElement("div")
		this.weekdays_element.classList.add("weekdays")
		this.calendarweek_element = document.createElement("div")
		this.calendarweek_element.classList.add("calendarweek")
		this.days_element = document.createElement("div")
		this.days_element.classList.add("days")

		// Node-Tree
		this.dropdownTarget.innerHTML = ""
		this.dropdownTarget.append(this.date_picker_element)
		this.date_picker_element.append(this.dates_element)
		this.dates_element.append(
			this.month_element,
			this.weekdays_element,
			this.calendarweek_element,
			this.days_element,
		)
		this.month_element.append(this.prev_mth_element, this.mth_element, this.next_mth_element)
	}

	populateDates() {
		this.days_element.innerHTML = ""
		this.calendarweek_element.innerHTML = ""

		// Durchlaufvariable Tag -> Start = Monatsanfang + Wochenanfang
		let day_i = moment(this.mth_element.textContent, "MMMM YYYY")
		day_i.startOf("month").startOf("week").startOf("day")

		for (let i = 0; i < 42; i++) {
			// Kalenderwoche
			if ((i + 7) % 7 == 0) {
				const kw = document.createElement("div")
				kw.classList.add("kw")
				kw.textContent = day_i.isoWeek()
				this.calendarweek_element.append(kw)
			}

			const day_element = document.createElement("div")
			day_element.classList.add("day")
			day_element.textContent = day_i.format("DD")
			day_element.dataset.date = day_i.format("DD.MM.YYYY")
			day_element.dataset.action = "click->datepicker#updateSelectedDate click->dropdown#close"

			// Heutigen Tag einfaerben
			if (day_i.isSame(moment(), "day")) {
				day_element.classList.add("today")
			}

			// Tage, die zu einem anderen Monat gehören, heller färben
			if (day_i.format("MMMM") != moment(this.mth_element.textContent, "MMMM YYYY").format("MMMM")) {
				day_element.classList.add("othermonth")
			}

			// Ausgewählten Tag einfaerben
			if (moment(this.datefieldTarget.value, "DD.MM.YYYY").format("DD.MM.YYYY") == day_i.format("DD.MM.YYYY")) {
				day_element.classList.add("selected")
			}

			// Element hinzufuegen und Tag erhoehen
			this.days_element.appendChild(day_element)
			day_i = day_i.add("1", "d")
		}
	}

	goToNextMonth() {
		const element = moment(this.mth_element.textContent, "MMMM YYYY")
		const nextMonth = element.add(1, "M")
		this.mth_element.textContent = nextMonth.format("MMMM YYYY")
		this.populateDates()
	}

	goToPrevMonth() {
		const element = moment(this.mth_element.textContent, "MMMM YYYY")
		const prevMonth = element.subtract(1, "M")
		this.mth_element.textContent = prevMonth.format("MMMM YYYY")
		this.populateDates()
	}

	populateWeekdays() {
		const weekdays = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"]
		weekdays.forEach((wd) => {
			const weekday_element = document.createElement("div")
			weekday_element.classList.add("weekday")
			weekday_element.textContent = wd
			this.weekdays_element.appendChild(weekday_element)
		})
	}

	updateSelectedDate({ currentTarget }) {
		// Alle Tage entfaerben
		const days = this.days_element.querySelectorAll(".day")
		days.forEach((d) => {
			d.classList.remove("selected")
		})

		// Ausgewählten Tag einfaerben
		currentTarget.classList.add("selected")

		// Selected Date anzeigen und Change Event auslösen
		this.datefieldTarget.value = moment(currentTarget.dataset.date, "DD.MM.YYYY").format("DD.MM.YYYY")
		this.datefieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
	}
}
